<template>
  <Modal :show="show" @close="onModalClose">
    <Flex relative>
      <Flex v-if="loading" absolute center class="full-modal"> <Spinner /> </Flex>
      <iframe :src="iframeSource" class="full-modal" @load="loading = false" />
    </Flex>
  </Modal>
</template>

<script>
import qs from 'qs'
import Modal from '@wizer/core/components/modal/Modal'
import Spinner from '@wizer/core/components/spinner/Spinner'
import Flex from '@wizer/core/components/flex/Flex'
import IframeMixin from '@/mixins/IframeMixin'
import ApiService from '@/services/ApiService'

export default {
  name: 'ConditionBuilder',
  mixins: [IframeMixin],
  components: {
    Modal,
    Spinner,
    Flex,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    componentId: String,
    conditionText: String,
    targetFieldName: String,
  },
  data() {
    return {
      loading: true,
      closed: false,
    }
  },
  async mounted() {
    this.registerListener('condition-builder-ok', (event) => {
      this.$emit('close', event.data)
    })
    this.registerListener('condition-builder-close', () => {
      this.$emit('close')
    })
  },
  methods: {
    onModalClose() {
      this.loading = true
      this.$emit('close')
    },
  },
  computed: {
    iframeSource() {
      const url = `${process.env.VUE_APP_E360_BASE_URL}${ApiService.prefix}conditionBuilder.jsp?`
      const params = {
        command: 'FilterBuilderLoad',
        componentId: this.componentId,
        conditionXml: this.conditionText ? encodeURIComponent(this.conditionText) : '<Condition />',
        lhsFieldMode: 'FIELD',
        configMode: 'COND_BLDR_CONF_MODE',
        targetFieldName: this.targetFieldName,
      }
      return url + qs.stringify(params, { indices: false })
    },
  },
}
</script>

<style scoped>
.full-modal {
  height: 80vh;
  width: 100%;
}
</style>
